export enum DataRecency {
  Current = "current",
  Relevant = "relevant",
  Stale = "stale",
}
